module.exports = __webpack_public_path__ + "img/ios-code.a577b2e0.png";